import { defineStore } from 'pinia';
import { paginateUrl } from './helpers';
import axios from 'axios';
import eventBus from '../eventBus';
import router from '../router';

export const useProfilesStore = defineStore('profiles', {
    state: () => ({
        profiles: []
    }),

    getters: {
        profile: (state) => {
            return (id) => state.profiles.find(profile => profile.id == id);
        },
    },

    actions: {
        _upsertProfile(payload) {
            const idx = this.profiles.findIndex(p => p.id === payload.id);
            if (idx !== -1) {
                this.profiles[idx] = payload;
            } else {
                this.profiles.push(payload);
            }
        },

        async readProfileTypes() {
            try {
                const response = await axios.get('/v1/profile-types');
                return response.data.data;
            } catch (error) {
                throw error.response ?? error;
            }
        },

        async syncProfile(payload) {
            try {
                const response = await axios.get('/v1/profiles/' + payload.profile.id + '/sync');
                return response.data;
            } catch (error) {
                if (error.response?.status == 404) {
                    const idx = this.profiles.findIndex(p => p.id === payload.profile.id);
                    if (idx !== -1) this.profiles.splice(idx, 1);
                }
                throw error.response ?? error;
            }
        },

        async readProfile(payload) {
            try {
                const response = await axios.get('/v1/profiles/' + payload.profile.id);
                this._upsertProfile(response.data.data);
                return response.data;
            } catch (error) {
                if (error.response?.status == 404) {
                    const idx = this.profiles.findIndex(p => p.id === payload.profile.id);
                    if (idx !== -1) this.profiles.splice(idx, 1);
                    router.push('/profiles');
                    return;
                }
                throw error.response ?? error;
            }
        },

        async readProfiles(payload) {
            const requestUrl = paginateUrl('/v1/profiles/?', payload.pagination);
            try {
                const response = await axios.get(requestUrl);
                const profiles = response.data.data;
                profiles.forEach(profile => {
                    this._upsertProfile(profile);
                });
                return response.data;
            } catch (error) {
                throw error.response ?? error;
            }
        },

        async createProfile(payload) {
            try {
                const response = await axios.post("/v1/profiles", payload.profile);
                this.profiles.push(response.data.data);
                return response.data;
            } catch (error) {
                throw error.response ?? error;
            }
        },

        async updateProfile(payload) {
            try {
                const response = await axios.put('/v1/profiles/' + payload.profile.id, payload.profile);
                this._upsertProfile(response.data.data);
                return response.data;
            } catch (error) {
                throw error.response ?? error;
            }
        },

        async deleteProfile(payload) {
            try {
                const response = await axios.delete("/v1/profiles/" + payload.profile.id);
                const idx = this.profiles.findIndex(p => p.id === payload.profile.id);
                if (idx !== -1) this.profiles.splice(idx, 1);
                return response.data;
            } catch (error) {
                throw error.response ?? error;
            }
        },

        async profileErrors(payload) {
            try {
                const response = await axios.get("/v1/profiles/" + payload.profile.id + "/errors");
                return response;
            } catch (error) {
                throw error.response ?? error;
            }
        },
    },

});
